var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('audio',{attrs:{"id":"audio","preload":"auto","muted":""}},[_c('source',{attrs:{"src":require("../data/notifications-audio/notification.mp3"),"type":"audio/mpeg"}}),_c('source',{attrs:{"src":require("../data/notifications-audio/notification.ogg"),"type":"audio/ogg"}})])
}]

export { render, staticRenderFns }